var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBottomWaveBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1439,
    height: 492,
    viewBox: "0 0 1439 492",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M458.674 153.312C235.046 193.393 59.7129 67.8045 0 0V492H1440V6.01222C1425.24 35.4053 1364.8 92.1874 1241.18 84.1711C1086.64 74.1507 1095.5 142.289 970.499 191.389C845.496 240.489 738.209 103.21 458.674 153.312Z",
    fill: "#7BD0FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomWaveBg);
export default __webpack_public_path__ + "static/media/bottomWaveBg.a7c53244bcdfb1dc538c44fb50655cca.svg";
export { ForwardRef as ReactComponent };